<template>
  <div>
    <slot name="default"/>
    <div class="skeleton space-y-8 animate-pulse md:space-y-0 md:space-x-8 rtl:space-x-reverse" :class="{ 'auto': auto, 'hidden': !auto && !showPlaceholder }">
      <slot name="placeholder"/>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  showPlaceholder?: boolean;
  auto?: boolean;
}

withDefaults(defineProps<Props>(), {
  showPlaceholder: true,
  auto: false,
});
</script>

<style scoped>
.skeleton.auto {
  display: none;
}

.skeleton.auto:only-child {
  display: block;
}
</style>